<template>
  <div class="editRuledetail">
    <el-container>
      <el-header>
        <div class="handlePanel"></div>
      </el-header>
      <el-main ref="main">
        <el-form
          :model="form"
          ref="uploadForm"
          class="demo-ruleForm"
          :rules="rules"
          style="width:900px;"
        >
          <el-row style="margin-right:34px;">
            <el-form-item label="名称：" label-width="117px" >
              <el-input v-model="form.policy" maxlength="200" :readonly="true" ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="内容：" label-width="117px" prop="policy">
<!--              <text-editor ref="textEditor"></text-editor>-->
              <VueUeditorWrap v-model="content3" :config="uediConfig"></VueUeditorWrap>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item class="btnList">
              <el-button type="primary" @click="saveRule()">保 存</el-button>
              <el-button type="info" @click="cancelRule()">取 消</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {
  getRuleService, //查询通知公告类型
  getRuleDetailService, //查询通知公告详情
  updateRuleDetailService //更新通知公告
} from "../../services/sysSettingService";
import VueUeditorWrap from '../../../public/ueditor/vue-ueditor-wrap/src/components/vue-ueditor-wrap'

export default {
  name: "editRuledetail",
  components: {
    VueUeditorWrap
    // textEditor
  },
  data() {
    return {
      form: {
        businessType: "", //通知公告类型
        policy: "", //政策
        typeExplain: "" //分类说明
      },
      rules: {
        // name: [
        //   { required: true, message: "请输入名称", trigger: "blur" }
        // ]

      },
      content3: "", //富文本编辑器内容
      // 文本编辑器
      uediConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 580,
        // 初始容器宽度
        initialFrameWidth: 750,
        UEDITOR_HOME_URL: "./ueditor/",
        serverUrl: "/xwj-sys-media/ueditor/upload/exec",
        readonly: false,
        enableAutoSave: true,
        saveInterval: 2000
      }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.form.businessType = this.tabRouteParam.label;
      this.getRuleDetail();
    },
    //获取列表
    getRuleDetail() {
      let businessType = this.form.businessType;
      getRuleDetailService(businessType)
        .then(res => {
          if (res.code == 10000000) {
            if(null!=res.data.id)
            {
               this.form = res.data;
            // this.$refs.textEditor.content=res.data.typeExplain
            this.content3=res.data.typeExplain

            }

          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    }, //

    saveRule() {
      let param = { ...this.form };
      // param.typeExplain = this.$refs.textEditor.content;
      param.typeExplain = this.content3;
      //更新通知公告
      updateRuleDetailService(param)
        .then(res => {
          if (res.code == 10000000) {
            this.$alert("保存成功", "提示", {
              confirmButtonText: "确定"
            });
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    },
    cancelRule() {
      let that = this;
      this.bus.$emit("tabClose", "editrulesTab");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.editRuledetail {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
.btnList {
  text-align: center;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
.editRuledetail{
    /deep/ .el-form-item__content{
        line-height: 20px;
    }
}

</style>
